export default __webpack_public_path__ + "static/media/Vambraces of the Vanguard.e9e28e04.jpg";